import React from "react";
import Breadcrumb from "commons/Breadcrumb";

/**
 * BreadcrumbPageLayout — a thin, presentational page layout: the standard
 * breadcrumb above the page content, sharing one consistent position/spacing.
 * Prop-fed (no routing/store reads); page content is children (keep
 * modals/drawers outside).
 *
 * @param {{
 *   crumbs?: Array<{ label: React.ReactNode, to?: string, onClick?: () => void }>,
 *   children: React.ReactNode,
 * }} props
 */
export default function BreadcrumbPageLayout({ crumbs = [], children }) {
  return (
    <div className="breadcrumb-page-layout">
      <Breadcrumb crumbs={crumbs} />
      {children}
    </div>
  );
}
